import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { IsNoU } from 'common/utils';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  }
}));

const styleTabPanel = ({
  margin: '10px',
});

const a11yProps = (index) => {
  return {
    id: `carinfo-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const CarInfos = props => {
  const { 
    className, 
    // areas,
    // groups,
    dashboard_info,
    ...rest 
  } = props;

  const classes = useStyles();

  const [tabIndex, setTabIndex] = useState(0);
  const [areaInfos, setAreaInfos] = useState([]);

  useEffect(() => {
    //console.log("componentDidMount");

    //if (IsNoU(areas) || IsNoU(infos) || areas.length <= tabIndex)
    if(IsNoU(dashboard_info) || IsNoU(dashboard_info.areas) || IsNoU(dashboard_info.deviceinfos))
      return ;

    let areas = dashboard_info.areas;
    let infos = dashboard_info.deviceinfos;

    if(IsNoU(areas) || IsNoU(infos))
      return ;

    //console.log(areas[tabIndex].name);
    //console.log(infos);

    if (areas.length <= 0 || infos.length <= 0)
      return ;

    const selectedArea = IsNoU(areas[tabIndex].name) ? undefined : areas[tabIndex].name;
    //const findInfos = infos.find(info => (info.area === selectedArea));
    const find_info = infos.find(info => (info.area.name === selectedArea));
    //setAreaInfos(newAreaInfo.infos);

    //console.log(find_info);

    let newAreaInfos = [];
    if (IsNoU(find_info) || IsNoU(find_info.group_infos) || find_info.group_infos.length <= 0) {
    }
    else {
      find_info.group_infos.map(area_group_info => {
        newAreaInfos.push({
          group: area_group_info.group.name,
          installed: area_group_info.devices.installed, //.filter(device => device.installed === '장착').length,
          mounted: area_group_info.devices.mounted, //find_info.devices.filter(device => device.installed === '장착').length,
          unmounted: area_group_info.devices.unmounted, //find_info.devices.filter(device => device.installed === '미장착').length,
        });
      })
    } 
    setAreaInfos(newAreaInfos);

  }, [tabIndex]); // empty-array means don't watch for any updates

  //console.log(infos);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        className={classes.card_header}
        title="차량운행현황"
      />
      <Divider />
      <CardContent className={classes.content}>
        <div style={styleTabPanel}></div>
        <Tabs 
          value={tabIndex} 
          onChange={(e, newValue) => setTabIndex(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="car infos tabs">
            {!IsNoU(dashboard_info.areas) && dashboard_info.areas.map((area, index) => (
              <Tab key={area.id} label={area.name} {...a11yProps(index)} />
            ))}
        </Tabs>
        <div style={styleTabPanel}></div>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>그룹</TableCell>
                  <TableCell>설치</TableCell>
                  <TableCell>정상</TableCell>
                  <TableCell>비정상</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {areaInfos.map((info, index) => (
                  <TableRow
                    hover
                    key={`arainfo-table-${index}`}
                  >
                    <TableCell>{info.group}</TableCell>
                    <TableCell>{info.installed}</TableCell>
                    <TableCell>
                      {/* {moment(order.createdAt).format('DD/MM/YYYY')} */}
                      {info.mounted}
                    </TableCell>
                    <TableCell>
                      {info.unmounted}
                      {/* <div className={classes.statusContainer}>
                        <StatusBullet
                          className={classes.status}
                          color={statusColors[order.status]}
                          size="sm"
                        />
                        {order.status}
                      </div> */}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      {/* <Divider /> */}
      {/* <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
          View all <ArrowRightIcon />
        </Button>
      </CardActions> */}
    </Card>
  );
};

CarInfos.propTypes = {
  className: PropTypes.string,
  infos: PropTypes.array.isRequired,
  areas: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
};

CarInfos.defaultProps = {
  infos: [],
  areas: [],
  groups: [],
};


export default CarInfos;
